"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validationRules = void 0;

var _formUtils = require("../internal/validation/formUtils");

var _states = require("../internal/validation/states");

var _valueCheck = require("../internal/utils/valueCheck");

var validationRules = function validationRules(props, repressError, value) {
  var error = props.error,
      getError = props.getError,
      label = props.label,
      masking = props.masking,
      minLength = props.minLength,
      maxLength = props.maxLength,
      required = props.required;
  var max = masking && masking.maskedMaxLength || maxLength;
  var rules = [// Has error prop
  {
    condition: !!error,
    msg: error,
    name: "errorProp"
  }, // Has custom validator as getError prop
  {
    condition: getError && !!getError(label, value),
    msg: getError && getError(label, value),
    name: "getErrorProp"
  }, // Value is empty and required
  {
    condition: !repressError && required && (0, _valueCheck.isValueFalsey)(value),
    msg: (0, _states.requiredErrorState)(label).msg,
    name: "isRequired"
  }, // Value length is greater than maxLength, applies to both masked and basic TextInput
  {
    condition: (0, _formUtils.validateLength)(value, max, "greaterThan"),
    msg: "'".concat(value, "', exceeds character limit of ").concat(max),
    // msg: `Value exceeds ${max} character limit`,
    name: "exceedsMaxLength"
  }, // Value length is less than required minLength
  {
    condition: !repressError && (0, _valueCheck.hasValue)(value) && (0, _formUtils.validateLength)(value, minLength, "lessThan"),
    msg: "".concat(minLength, " characters required"),
    name: "lessThanMinLength"
  }];
  var validationState = _states.validState;

  for (var _i = 0, _rules = rules; _i < _rules.length; _i++) {
    var rule = _rules[_i];

    if (rule.condition === true) {
      validationState = {
        msg: rule.msg,
        type: "error"
      };
      break;
    }
  }

  return validationState;
};

exports.validationRules = validationRules;